<template>
    <div class="modal modal-open" id="modal-add-sow-to-deal">
        <div class="modal-overflow">
            <div class="modal-window">
                <button
                    class="btn btn-modal-close"
                    type="button"
                    @click="handleCloseModal"
                >
                    <i class="icon icon-cancel"></i>
                </button>
                <div class="modal-body">
                    <div class="row">
                        <div
                            class="col-xl-12 col-lg-12 col-md-12 text-center modal-title"
                        >
                            If the monthly fee has changed, you need to add a
                            new sow
                        </div>
                    </div>
                    <div class="row jus-c--space-between">
                        <div class="col-xl-11 col-lg-11 col-md-11">
                            <div class="form-field form-field--text">
                                <label for="sow_title">Title</label>
                                <input
                                    type="text"
                                    id="sow_title"
                                    v-model="sow.title"
                                    name="sow_title"
                                />
                                <!-- <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.title"
                                    >{{ errors.title }}</span
                                > -->
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-5 col-lg-5 col-md-5">
                            <div
                                class="form-field form-field--datepicker"
                                ref="datepicker"
                            >
                                <label for="sow_date"
                                    >Date<span class="red">*</span></label
                                >
                                <input
                                    type="text"
                                    id="sow_date"
                                    v-model="sow.date"
                                    name="sow_date"
                                    @changeDate="onChangeDatePicker"
                                />
                                <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.date"
                                    >{{ errors.date }}</span
                                >
                                <button type="button" class="btn btn--icon">
                                    <i class="icon icon-calendar"></i>
                                </button>
                            </div>
                        </div>
                        <div class="col-xl-5 col-lg-5 col-md-5">
                            <div
                                class="form-field form-field--datepicker"
                                ref="valid_datepicker"
                            >
                                <label for="sow_date">Valid until</label>
                                <input
                                    type="text"
                                    id="sow_date"
                                    v-model="sow.valid_date"
                                    name="sow_date"
                                    @changeDate="onChangeValidDatePicker"
                                />
                                <button type="button" class="btn btn--icon">
                                    <i class="icon icon-calendar"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div
                                class="form-field form-field--radiobutton form-field--radiobutton-sow"
                            >
                                <input
                                    type="radio"
                                    id="sow_type_file"
                                    name="type"
                                    :checked="sow.type === 'file'"
                                    @change="onChangeSowType('file')"
                                />
                                <label for="sow_type_file">File</label>
                                <div
                                    class="form-field form-field--file"
                                    ref="filepicker"
                                >
                                    <input
                                        type="file"
                                        id="agreement"
                                        name="agreement"
                                        hidden
                                        ref="fileInput"
                                        @input="pickFile"
                                        @change="pickFile"
                                    />
                                    <button type="button" class="btn btn--file">
                                        File
                                        <i class="icon icon-plus"></i>
                                    </button>
                                    <span
                                        class="filename"
                                        v-if="sow.filename"
                                        >{{ sow.filename }}</span
                                    >
                                </div>
                                <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.file"
                                    >{{ errors.file }}</span
                                >
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div
                                class="form-field form-field--radiobutton form-field--radiobutton-sow"
                            >
                                <input
                                    type="radio"
                                    id="sow_type_url"
                                    name="type"
                                    :checked="sow.type === 'url'"
                                    @change="onChangeSowType('url')"
                                />
                                <label for="sow_type_url">URL</label>
                                <div class="form-field form-field--text">
                                    <input
                                        type="text"
                                        id="sow_url"
                                        v-model="sow.url"
                                        name="sow_url"
                                    />
                                </div>
                                <span
                                    @click="openLeadsFolderLink"
                                    style="margin-left: 8px; color: red"
                                    ><i class="icon icon-external-link"></i
                                ></span>
                                <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.url"
                                    >{{ errors.url }}</span
                                >
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div class="form-field form-field--radiobutton">
                                <input
                                    type="radio"
                                    name="type"
                                    id="sow_type_none"
                                    :checked="sow.type === 'none'"
                                    @change="onChangeSowType('none')"
                                />
                                <label for="sow_type_none"
                                    >I don’t have a signed SOW</label
                                >
                                <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.type"
                                    >{{ errors.type }}</span
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div class="form-field form-field--textarea">
                                <label for="sow_description">Explanation</label>
                                <textarea
                                    id="sow_description"
                                    v-model="sow.description"
                                    name="sow_description"
                                ></textarea>
                                <span
                                    style="left: 0"
                                    class="error"
                                    v-if="errors.description"
                                    >{{ errors.description }}</span
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row jus-c--center">
                        <div class="col-xl-4 col-lg-4">
                            <div class="btn-wrap jus-c--center">
                                <button
                                    @click="handleSubmit"
                                    type="button"
                                    class="btn"
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4">
                            <div class="btn-wrap jus-c--center">
                                <button
                                    @click="handleCloseModal"
                                    type="button"
                                    class="btn"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Datepicker } from "vanillajs-datepicker";
import moment from "moment";

export default {
    name: "Add_Sow_To_Deal",
    props: {
        onClose: {
            type: Function,
        },
        onSubmit: {
            type: Function,
        },
        brand_name: String,
        deal_id: String | Number,
    },
    mounted() {
        this.initDatePicker();
        this.initValidDatePicker();
        this.initFilePicker();
        this.getSOWList();
    },
    computed: {
        currentDate() {
            return moment().format("MMDDYYYY");
        },
    },
    data() {
        return {
            sow: {
                type: "file",
                title: "",
                date: null,
                valid_date: null,
                file: null,
                description: "",
                filename: "",
                url: "",
            },
            errors: {
                //title: null,
                date: null,
                file: null,
                url: null,
                type: null,
                description: null,
                //valid_date: null,
            },
            datepicker_options: {
                format: "mm/dd/yyyy",
                pickLevel: 0,
            },
        };
    },
    methods: {
        handleSubmit() {
            this.validateFields();

            if (
                this.errors.date ||
                this.errors.description ||
                this.errors.file ||
                this.errors.type ||
                this.errors.url
            ) {
                return;
            }

            const data = {
                sow_name: this.sow.title,
                sow_date: this.sow.date === null ? "" : this.sow.date,
                sow_file: this.sow.file,
                sow_url: this.sow.url,
                sow_description: this.sow.description,
                sow_type: this.sow.type,
                sow_valid_date: this.sow.valid_date,
            };

            this.onSubmit(data);
        },

        handleCloseModal() {
            this.clear();
            this.onClose();
        },

        validateFields() {
            this.errors.date = null;
            //this.errors.title = null;
            this.errors.file = null;
            this.errors.description = null;
            this.errors.type = null;
            this.errors.url = null;
            //this.errors.valid_date = null;

            // if (!this.sow.title) {
            //     this.errors.title = "Required";
            // }

            if (!this.sow.date) {
                this.errors.date = "Required";
            }

            // if (!this.sow.valid_date) {
            //     this.errors.valid_date = "Required";
            // }

            if (!this.sow.type) {
                this.errors.type = "Please select sow type";
            }
            if (this.sow.type === "file" && !this.sow.file) {
                this.errors.file = "File is required";
            }

            if (this.sow.type === "url" && !this.sow.url) {
                this.errors.url = "URL is required";
            }

            if (
                !this.check_sow &&
                this.sow.type === "none" &&
                !this.sow.description
            ) {
                this.errors.description = "Description is required";
            }
        },

        clear() {},

        initDatePicker() {
            const node__datepicker = this.$refs.datepicker;

            if (!node__datepicker) {
                return;
            }

            let datepicker = null;
            const input = node__datepicker.querySelector("input");
            const button = node__datepicker.querySelector("button");

            if (input) {
                datepicker = new Datepicker(input, {
                    ...this.datepicker_options,
                });
            }

            if (button) {
                button.addEventListener("click", () => {
                    if (!datepicker.active) {
                        datepicker.show();
                    }
                });
            }
        },

        onChangeSowType(type = "file") {
            this.sow.type = type;

            if (type === "none" && !this.sow.date) {
                this.sow.date = moment().format("MM/DD/yyyy");
            }
        },

        openLeadsFolderLink() {
            const _leads_folder = this.sow.url;

            var res = _leads_folder
                .toString()
                .match(
                    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
                );
            if (res) {
                window.open(_leads_folder, "_blank");
            }
        },

        initValidDatePicker() {
            const node__datepicker = this.$refs.valid_datepicker;

            if (!node__datepicker) {
                return;
            }

            let datepicker = null;
            const input = node__datepicker.querySelector("input");
            const button = node__datepicker.querySelector("button");

            if (input) {
                datepicker = new Datepicker(input, {
                    ...this.datepicker_options,
                });
            }

            if (button) {
                button.addEventListener("click", () => {
                    if (!datepicker.active) {
                        datepicker.show();
                    }
                });
            }
        },

        onChangeDatePicker(e) {
            const date = e.target.value;

            if (date) {
                this.sow.date = date;
            }
        },

        onChangeValidDatePicker(e) {
            const date = e.target.value;

            if (date) {
                this.sow.valid_date = date;
            }
        },

        initFilePicker() {
            const inputField = this.$refs.filepicker;

            if (!inputField) {
                return;
            }

            const button = inputField.querySelector("button");
            const input = inputField.querySelector("input");
            const filenameNode = inputField.querySelector("span.filename");

            if (button && input) {
                button.addEventListener("click", () => {
                    input.click();
                });
            }

            input.addEventListener("change", () => {
                let file = input.files;
                if (file && file[0]) {
                    const filename = file[0].name;
                    this.sow.filename = filename;
                    filenameNode.innerHTML = filename;
                    this.sow.file = file[0];
                }
            });
        },
        pickFile() {
            let input = this.$refs.fileInput;
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader();
                reader.readAsDataURL(file[0]);
                this.sow.file = file[0];
            }
        },

        getSOWList() {
            axios
                .post("/deals/sow/getList", {
                    deal_id: this.deal_id,
                })
                .then((response) => {
                    if (response.data.isSuccess) {
                        const lastIndex = response.data.items.length + 1;

                        this.sow.title = `${this.brand_name}-${this.currentDate}-${lastIndex}`;
                    }
                })
                .catch((err) => {
                    console.log("ERROR getSOWList", err);
                });
        },
    },
};
</script>
